import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { LoadingProgressBar } from "@rentablo/components";
import { endImpersonation } from "./impersonateTokenHandler";

const Container = styled.div`
  width: 100%;
`;

export const EndImpersonation = () => {
  useEffect(() => {
    endImpersonation();
    window.location.href = `${
      import.meta.env.VITE_APP_ROOT_URL
    }/admin/findUser`;
  }, []);

  return (
    <Container>
      <LoadingProgressBar />
    </Container>
  );
};
